{
    "menuList": [
        {
            "id": 1,
            "name": "Catalog & Content",
            "icon": "snippets.svg",
            "open": false,
            "routes": [
                "dashboard",
                "content-dashboard",
                "content-page",
                "content-list",
                "master-catalog"
            ],
            "subMenuList": [
                {
                    "id": 1,
                    "name": "Customer Catalog",
                    "route": "dashboard",
                    "key": "dashboard"
                },
                {
                    "id": 2,
                    "name": "Master Catalog",
                    "route": "master-catalog",
                    "key": "master"
                },
                {
                    "id": 3,
                    "name": "Content Management",
                    "route": "content-dashboard",
                    "key": "content"
                }
            ]
        },
        {
            "id": 2,
            "name": "Site Administration",
            "icon": "solution.svg",
            "open": false,
            "routes": [
                "associate-customers",
                "price-display-setup",
                "sequence-dim"                
            ],
            "subMenuList": [
                {
                    "id": 1,
                    "name": "Associate Customers to Site",
                    "route": "associate-customers",
                    "key": "associate"
                },
                {
                    "id": 2,
                    "name": "Price Display Setup",
                    "route": "price-display-setup",
                    "key": "price"
                },
                {
                    "id": 3,
                    "name": "Size Definition",
                    "route": "sequence-dim",
                    "key": "size"
                }                
            ]
        },
        {
            "id": 3,
            "name": "Miscellaneous",
            "icon": "sliders.svg",
            "open": false,
            "routes": [
                "amdjob-allocate",
                "fedorgcode-mapping"
            ],
            "subMenuList": [
                {
                    "id": 1,
                    "name": "AMD Location - Job-code Management",
                    "route": "amdjob-allocate",
                    "key": "amdjob"
                },
                {
                    "id": 2,
                    "name": "FedEx Org. code - Location Management",
                    "route": "fedorgcode-mapping",
                    "key": "fedorgcode"
                }
            ]
        }
    ]
}